import { InsuranceOfferParametersGeneration } from './InsuranceOfferParametersGeneration'
import * as Sentry from '@sentry/react'
import { saving, setErrors } from '@/containers/OrganizationsManagement/organizationsManagementSlice'

const SaveInsuranceOffer = async (providerState, dispatch, url, headers, sendRequest, country, { onSuccess } = {}) => {
  dispatch(saving({ loading: true }))

  headers.body = InsuranceOfferParametersGeneration(providerState.selectedOffer, providerState.selectedProvider.id)

  await sendRequest(url, headers, (json, status) => {
    if (status === 200) {
      dispatch(setErrors({}))
      onSuccess?.()
    }
    if (status === 422) {
      dispatch(setErrors(json.errors))
    }

    if (json.errors) {
      if (import.meta.env.PROD) {
        Sentry.captureException(new Error('Errors in SaveInsuranceOffer'), { extra: { context: 'SaveInsuranceOffer', errors: json.errors } })
      }
    }

    dispatch(saving({ loading: false }))
  })
}

export default SaveInsuranceOffer
